import Component from "../../Component";
import BaseApi from "./BaseApi";
import { Department } from "../types";
// Define types for better type safety

/**
 * Department API - Handles all department-related operations
 * Extends BaseApi for consistent error handling and authentication
 * Follows Single Responsibility Principle
 */
export default class DepartmentApi extends BaseApi {
    constructor(component: Component) {
        super(component);
    }

    /**
     * Fetches all available departments
     * @returns Promise<Department[]> Array of all departments
     */
    public async fetchAllDepartments(): Promise<Department[]> {
        return this.fetchWithAuth<Department[]>("/departments");
    }
}
